import { getGlobalRenderingEngine } from "./renderingEngine";

let activeViewportId = null;
export function setActiveViewportId(id) {
  activeViewportId = id;
}

function getActiveViewportId() {
  return activeViewportId;
}

export async function applyWindowLevel(preset) {
  const WL_PRESETS = {
    softTissue: { windowWidth: 400, windowCenter: 40 },
    Bone: { windowWidth: 2000, windowCenter: 500 },
    Lung: { windowWidth: 1500, windowCenter: -600 },
    Liver: { windowWidth: 150, windowCenter: 70 },
    Brain: { windowWidth: 80, windowCenter: 40 },
    brainInfarct: { windowWidth: 40, windowCenter: 40 },
  };

  const config = WL_PRESETS[preset];
  if (!config) return;

  const renderingEngine = await getGlobalRenderingEngine();
  const viewport = renderingEngine.getViewport(activeViewportId);

  if (!viewport) {
    console.warn("Viewport not found:", activeViewportId);
    return;
  }

  viewport.setProperties({
    voiRange: {
      lower: config.windowCenter - config.windowWidth / 2,
      upper: config.windowCenter + config.windowWidth / 2,
    },
  });

  viewport.render();
}
export async function setMPRView(type) {
  const renderingEngine = await getGlobalRenderingEngine();
  const viewportId = getActiveViewportId(); // ← active panel ka viewport
  const viewport = renderingEngine.getViewport(viewportId);
  if (!viewport) return;
  if (type === "axial") {
    viewport.setOrientation("axial");
  } else if (type === "sagittal") {
    viewport.setOrientation("sagittal");
  } else if (type === "coronal") {
    viewport.setOrientation("coronal");
  }
  viewport.render();
}